import React, { useState } from "react";
import book from "../images/book.png";
import BookNowDrawer from "./BookNowDrawer";

const BookNow = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        id="toTop"
        className="whatsapp-button"
        onClick={() => setOpen(true)}
        style={{
          opacity: 1,
          visibility: "visible",
          background: "transparent",
          border: "none",
          padding: "0px",
          cursor: "pointer",
          bottom: "75px",
        }}
      >
        <img
          className="whatsapp-size-full wp-image-861 alignnone"
          src={book}
          alt="book now"
        />
      </button>

      <BookNowDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default BookNow;
